import React from 'react';
import {
	MonitoringCenterCase,
	MonitoringCenterTable,
} from '../Components/MonitoringCenterListTable/MonitoringCenterListTable';
import styles from '../Components/MonitoringCenterAllRequests/MonitoringCenterAllRequests.module.scss';
import MonitoringCenterLabelColumn from '../Components/MonitoringCenterItemCols/MonitoringCenterLabelColumn';
import PatientProfileButtonWithVirtualSelection from '../../Patient/Components/PatientProfileButtonWithVirtualSelection/PatientProfileButtonWithVirtualSelection';
import { FormattedDateTime } from '../../../Components/FormattedDate';
import Tooltip from '../../../Components/Popup/Tooltip';
import CaseMedicalReportButtonList from '../../Case/Components/CaseMedicalReportButtonList/CaseMedicalReportButtonList';
import MonitoringCenterSolvedControlsColumn from '../Components/MonitoringCenterItemCols/MonitoringCenterSolvedControlsColumn';
import MonitoringCenterAttendingDoctorColumn from '../Components/MonitoringCenterItemCols/MonitoringCenterAttendingDoctorColumn';
import { DataTableColumn } from '../../Base/Components/DataTable/DataTable';

export const MonitoringCenterSolvedCasesColumns: DataTableColumn<
	MonitoringCenterCase,
	MonitoringCenterTable
>[] = [
	{
		key: 'number',
		label: 'component.monitoringCenter.tableHead.number',
		renderItem: (item: MonitoringCenterCase) => item.code,
	},
	{
		key: 'requestType',
		label: 'component.monitoringCenter.tableHead.requestType',
		bold: true,
		renderItem: (item: MonitoringCenterCase) => (
			<MonitoringCenterLabelColumn item={item} />
		),
	},
	{
		key: 'patient',
		label: 'component.monitoringCenter.tableHead.patient',
		renderItem: (item: MonitoringCenterCase) => (
			<PatientProfileButtonWithVirtualSelection
				patientId={item.patient.id}
				isVirtual={!!item.patient.originalId}
				title={item?.patient?.profile?.fullName}
				className={styles.patientButton}
			/>
		),
	},
	{
		key: 'birthNumber',
		label: 'component.monitoringCenter.tableHead.birthNumber',
		renderItem: (item: MonitoringCenterCase) =>
			item?.patient?.profile?.formattedBirthNumber,
	},
	{
		key: 'attendingDoctor',
		label: 'component.monitoringCenter.tableHead.attendingDoctor',
		bold: true,
		renderItem: (item: MonitoringCenterCase) => (
			<MonitoringCenterAttendingDoctorColumn item={item} />
		),
	},
	{
		key: 'closedBy',
		label: 'component.monitoringCenter.tableHead.closedBy',
		renderItem: (item: MonitoringCenterCase) => {
			const doctorProfile = item?.doctor?.profile;

			if (!doctorProfile) {
				return undefined;
			}

			return (
				<Tooltip
					trigger={`${doctorProfile.salutationBefore} ${doctorProfile.lastName}`.trim()}>
					{doctorProfile.fullName}
				</Tooltip>
			);
		},
	},
	{
		key: 'workplace',
		label: 'component.monitoringCenter.tableHead.workplace',
		renderItem: (item: MonitoringCenterCase) => item?.workplace?.codeName,
	},
	{
		key: 'diagnosis',
		label: 'component.monitoringCenter.tableHead.diagnosis',
		renderItem: (item: MonitoringCenterCase) => item.diagnosis,
	},
	{
		key: 'closedWith',
		label: 'component.monitoringCenter.tableHead.closedWith',
		renderItem: (item: MonitoringCenterCase) => (
			<>
				{item.medicalReports?.length && (
					<CaseMedicalReportButtonList
						items={item.medicalReports}
						patientId={item.patient.id}
					/>
				)}
			</>
		),
	},
	{
		key: 'created',
		label: 'component.monitoringCenter.tableHead.created',
		renderItem: (item: MonitoringCenterCase) => (
			<FormattedDateTime datetime={item.createdAt} />
		),
	},
	{
		key: 'closed',
		label: 'component.monitoringCenter.tableHead.closed',
		renderItem: (item: MonitoringCenterCase) => (
			<FormattedDateTime datetime={item.updatedAt} />
		),
	},
	{
		key: 'controls',
		label: '',
		visible: true,
		renderItem: (item: MonitoringCenterCase) => (
			<MonitoringCenterSolvedControlsColumn item={item} />
		),
	},
];
